import { isValidCountry } from './CountryValidation';

const defaultUserLocation = {
  country_code: 'IN',
  state_code: 'MH',
  state: 'MAHARASHTRA',
  country: 'INDIA',
  city: 'MUMBAI'
};

/**
 * "x-akamai-edgescape":"country_code=IN,region_code=KA,city=BANGALORE"
 *
 */
export const getUserLocationFromAkamaiEdgescape = (header = '') => {
  const userLocationArray = header.match(/\w+=\w+/gm) || [];
  const userLocationObject = {
    country_code: '',
    state_code: '',
    country: '',
    city: '',
    state: ''
  };

  userLocationArray.forEach((pair: string) => {
    const [key, val] = pair.split('=');
    userLocationObject[key as keyof typeof userLocationObject] = val;
  });

  return userLocationObject;
};

/**
 * returns userLocation object
 * if no cookie exist return default location object
 */
export const getUserLocationObject = (countryCode = '') => {
  if (countryCode && isValidCountry(countryCode)) {
    return {
      country_code: countryCode,
      state_code: '',
      country: '',
      city: '',
      state: ''
    };
  }
  return defaultUserLocation;
};
